<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Descrição
          </th>
          <th class="text-center">
            Valor
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="visita.cliente">
          <td v-text="`Cliente`" />
          <td
            class="text-center"
            v-text="visita.cliente.nome"
          />
        </tr>
        <tr v-if="visita.tecnico">
          <td v-text="`Técnico principal`" />
          <td
            class="text-center"
            v-text="visita.tecnico.nome"
          />
        </tr>
        <tr v-if="visita.tecnico_2_id">
          <td v-text="`Técnico complementar`" />
          <td
            class="text-center"
            v-text="visita.tecnico_complementar.nome"
          />
        </tr>
        <tr>
          <td v-text="`Proporção`" />
          <td
            class="text-center"
            v-text="visita.proporcao"
          />
        </tr>
        <tr>
          <td v-text="`Data da visita`" />
          <td
            class="text-center"
            v-text="$options.filters.date(visita.data_visita)"
          />
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['visita'])
  }
}
</script>
